import React from 'react';

/**
 * Shared Apple-inspired dark UI primitives for the redesigned /albaniaadmin
 * experience. Pure black background, soft glass panels, white type.
 */

export const GlassPanel: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <div
    className={`rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-xl ${className || ''}`}
  >
    {children}
  </div>
);

export const PillButton: React.FC<{
  children: React.ReactNode;
  onClick?: () => void;
  active?: boolean;
  className?: string;
  type?: 'button' | 'submit';
  disabled?: boolean;
}> = ({ children, onClick, active, className, type = 'button', disabled }) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={`rounded-full px-5 py-2.5 text-xs font-medium tracking-wide transition-all duration-300 ${
      active
        ? 'bg-white text-black shadow-lg shadow-white/10'
        : 'border border-white/15 text-white/70 hover:border-white/40 hover:text-white'
    } ${disabled ? 'opacity-40 cursor-not-allowed' : ''} ${className || ''}`}
  >
    {children}
  </button>
);

export const StatBadge: React.FC<{ children: React.ReactNode; tone?: 'gold' | 'green' | 'amber' | 'blue' }> = ({
  children,
  tone = 'gold',
}) => {
  const tones: Record<string, string> = {
    gold: 'bg-[#C9A961]/15 text-[#E4C77F] border-[#C9A961]/30',
    green: 'bg-emerald-400/10 text-emerald-300 border-emerald-400/25',
    amber: 'bg-amber-400/10 text-amber-300 border-amber-400/25',
    blue: 'bg-sky-400/10 text-sky-300 border-sky-400/25',
  };
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[10px] font-medium uppercase tracking-wider ${tones[tone]}`}
    >
      {children}
    </span>
  );
};

export const SectionTitle: React.FC<{
  eyebrow?: string;
  title: string;
  subtitle?: string;
}> = ({ eyebrow, title, subtitle }) => (
  <div className="mb-8">
    {eyebrow && (
      <div className="mb-2 text-[11px] font-medium uppercase tracking-[0.3em] text-[#C9A961]">
        {eyebrow}
      </div>
    )}
    <h2 className="text-3xl font-light tracking-tight text-white sm:text-4xl">{title}</h2>
    {subtitle && <p className="mt-3 max-w-2xl text-sm leading-relaxed text-white/50">{subtitle}</p>}
  </div>
);
